export default __webpack_public_path__ + "static/media/paso28.946b027c.png";